var path = 'app/components/common/views/content.html';
var html = "<div id=\"wrapper\" fit-height><navbar></navbar><div ui-view></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/common/views/content.html
// module id = 354
// module chunks = 0